import { Button } from "@/components/ui/button/button";
import { SelectField } from "@/components/ui/form/fields/select-field";
import { DatePickerRange } from "@/components/ui/input/date-picker-range";

import { SALES_MAST_TYPE_OPTIONS } from "./constants";
import { useHandleSearchActions } from "./hooks";

import type { SearchTypeForSearchSalesMastList } from "../../../../model/constants";
import type { OnSearchSalesMastListProps } from "../../../../model/use-case/use-search-reservation-list";

type Props = {
	// 収支の検索
	onSearchSalesMastList: (props: OnSearchSalesMastListProps) => void;

	searchType: SearchTypeForSearchSalesMastList;
	onSetSearchType: (type: SearchTypeForSearchSalesMastList) => void;
};

export const BasicSearchSection = ({ searchType: _searchType, onSetSearchType, onSearchSalesMastList }: Props) => {
	const {
		searchState,
		//
		searchType,
		disabled,
		//
		// 予約タイプの変更
		handleChangeSearchType,
		// 日付の変更
		handleChangeFromAndTo,
		// 修正の検索
		handleClickSearchSalesMastList,
	} = useHandleSearchActions({
		onSearchSalesMastList,
		searchType: _searchType, //
		onSetSearchType,
	});

	return (
		<div className="grid grid-cols-1 items-center gap-4 tablet:flex">
			{/* 検索タイプ */}
			<SelectField
				value={searchType}
				options={SALES_MAST_TYPE_OPTIONS}
				handleValueChange={handleChangeSearchType}
			/>

			{/* 日付での絞り込み */}
			<DatePickerRange
				selected={{
					from: searchState.from,
					to: searchState.to,
				}}
				onSelect={handleChangeFromAndTo}
				showPresetOptions="exclude-future-options"
				canSelectPastDate
				className="w-full tablet:w-80"
			/>

			<Button type="button" disabled={disabled} onClick={handleClickSearchSalesMastList}>
				検索
			</Button>
		</div>
	);
};

BasicSearchSection.displayName = "BasicSearchSection";
